export default __webpack_public_path__ + "static/media/loyalty-overlay.11ac6cfa.svg";